// Bilingual FR/EN dictionary for Suno-like clone
export const dictionaries = {
  fr: {
    nav: {
      home: 'Accueil',
      create: 'Créer',
      library: 'Bibliothèque',
      explore: 'Explorer',
      search: 'Rechercher',
      upgrade: 'Passer Pro',
      signin: 'Se connecter',
      signup: "S'inscrire",
      logout: 'Déconnexion',
      credits: 'crédits',
      settings: 'Paramètres',
      profile: 'Profil',
    },
    home: {
      hero_title: 'Crée ton premier son',
      hero_sub: "Décris une vibe, ajoute ta voix, laisse l'IA composer. Rap, Afro, Dancehall, Reggae.",
      start: 'Commencer à créer',
      trending: 'Tendances cette semaine',
      forYou: 'Pour toi',
      newReleases: 'Nouveautés',
      genreSpotlight: 'Genres à la une',
    },
    create: {
      title: 'Studio de création',
      subtitle: 'Décris ta chanson, ajoute des paroles, choisis un style.',
      simple: 'Simple',
      custom: 'Personnalisé',
      song_desc: 'Description de la chanson',
      song_desc_ph: 'Un morceau dancehall ensoleillé avec une basse profonde et une voix masculine chaleureuse...',
      lyrics: 'Paroles',
      lyrics_ph: 'Écris tes paroles ou laisse l’IA les générer...',
      instrumental: 'Instrumental',
      style: 'Style de musique',
      style_ph: 'rap, afro, dancehall, reggae...',
      title_field: 'Titre',
      title_ph: 'Donne un titre à ta chanson',
      voice: 'Ma voix',
      voice_hint: 'Enregistre ou téléverse un extrait pour cloner ta voix',
      record: 'Enregistrer',
      stop: 'Stop',
      upload: 'Téléverser',
      generate_lyrics: 'Générer les paroles avec l’IA',
      generate_song: 'Générer la chanson',
      generating: 'Génération en cours...',
      genres: 'Genres rapides',
      moods: 'Ambiances',
      instruments: 'Instruments traditionnels',
      tip: 'Astuce : combine 2-3 genres pour des résultats uniques',
    },
    library: {
      title: 'Bibliothèque',
      songs: 'Chansons',
      playlists: 'Playlists',
      liked: 'Aimées',
      empty: 'Aucune chanson encore. Va dans Créer pour commencer.',
      new_playlist: 'Nouvelle playlist',
      pl_title_ph: 'Nom de la playlist',
      add_to_playlist: 'Ajouter à une playlist',
      created: 'Playlist créée',
      added_to: 'Ajouté à',
    },
    explore: {
      title: 'Explorer',
      subtitle: 'Découvre les meilleures créations de la communauté',
      filters: 'Filtres',
    },
    settings: {
      title: 'Paramètres',
      profile: 'Profil',
      name: 'Nom',
      bio: 'Bio',
      bio_ph: 'Parle un peu de toi...',
      save: 'Enregistrer',
      saved: 'Enregistré',
      privacy: 'Confidentialité',
      privacy_desc: 'Choisis si tes chansons sont publiques (visibles sur Explorer et via leur lien) ou privées.',
      song: 'Chanson',
      public: 'Publique',
      private: 'Privée',
      credits: 'Crédits',
      buy: 'Acheter des crédits',
      pack_small: 'Pack 100 crédits',
      pack_medium: 'Pack 500 crédits',
      pack_large: 'Pack 2000 crédits',
      buy_mock: 'Paiement MOCKÉ — crédits ajoutés instantanément',
      delete_song: 'Supprimer',
      confirm_delete: 'Supprimer cette chanson ?',
    },
    profile: {
      follow: 'Suivre',
      unfollow: 'Ne plus suivre',
      followers: 'abonnés',
      following: 'abonnements',
      songs: 'chansons',
      no_songs: 'Aucune chanson publique',
      edit: 'Modifier le profil',
    },
    share: {
      title: 'Partager',
      copy_link: 'Copier le lien',
      copied: 'Lien copié !',
      by: 'par',
      comments: 'Commentaires',
      comment_ph: 'Laisse un commentaire...',
      send: 'Envoyer',
      sign_in_to_comment: 'Connecte-toi pour commenter',
    },
    player: {
      play: 'Lire',
      pause: 'Pause',
      next: 'Suivant',
      prev: 'Précédent',
      like: 'Aimer',
      share: 'Partager',
      download: 'Télécharger',
      download_song: 'Chanson complète',
      download_vocals: 'Voix (stem)',
      download_instrumental: 'Instrumental (stem)',
      stems_note: 'Stems mockés pour la démo',
      lyrics: 'Paroles',
      noTrack: 'Aucune piste sélectionnée',
    },
    auth: {
      welcome: 'Bienvenue sur',
      tag: 'Crée des chansons originales en quelques clics.',
      email: 'Email',
      password: 'Mot de passe',
      signin_cta: 'Se connecter',
      signup_cta: 'Créer un compte',
      have_account: 'Déjà un compte ?',
      no_account: 'Pas encore de compte ?',
      or: 'OU',
      continue_google: 'Continuer avec Google',
      name: 'Nom',
    },
    common: {
      plays: 'écoutes',
      likes: 'j\'aime',
      by: 'par',
      duration: 'durée',
      copy: 'Copier',
      copied: 'Copié !',
      remix: 'Remixer',
      more: 'Plus',
    }
  },
  en: {
    nav: {
      home: 'Home',
      create: 'Create',
      library: 'Library',
      explore: 'Explore',
      search: 'Search',
      upgrade: 'Upgrade',
      signin: 'Sign in',
      signup: 'Sign up',
      logout: 'Log out',
      credits: 'credits',
      settings: 'Settings',
      profile: 'Profile',
    },
    home: {
      hero_title: 'Make your first song',
      hero_sub: 'Describe a vibe, add your voice, let AI compose. Rap, Afro, Dancehall, Reggae.',
      start: 'Start creating',
      trending: 'Trending this week',
      forYou: 'For you',
      newReleases: 'New releases',
      genreSpotlight: 'Genre spotlight',
    },
    create: {
      title: 'Create studio',
      subtitle: 'Describe your song, add lyrics, pick a style.',
      simple: 'Simple',
      custom: 'Custom',
      song_desc: 'Song description',
      song_desc_ph: 'A sunny dancehall track with deep bass and warm male vocals...',
      lyrics: 'Lyrics',
      lyrics_ph: 'Write your lyrics or let AI generate them...',
      instrumental: 'Instrumental',
      style: 'Music style',
      style_ph: 'rap, afro, dancehall, reggae...',
      title_field: 'Title',
      title_ph: 'Give your song a title',
      voice: 'My voice',
      voice_hint: 'Record or upload a sample to clone your voice',
      record: 'Record',
      stop: 'Stop',
      upload: 'Upload',
      generate_lyrics: 'Generate lyrics with AI',
      generate_song: 'Generate song',
      generating: 'Generating...',
      genres: 'Quick genres',
      moods: 'Moods',
      instruments: 'Traditional instruments',
      tip: 'Tip: combine 2-3 genres for unique results',
    },
    library: {
      title: 'Library',
      songs: 'Songs',
      playlists: 'Playlists',
      liked: 'Liked',
      empty: 'No songs yet. Go to Create to start.',
      new_playlist: 'New playlist',
      pl_title_ph: 'Playlist name',
      add_to_playlist: 'Add to playlist',
      created: 'Playlist created',
      added_to: 'Added to',
    },
    explore: {
      title: 'Explore',
      subtitle: 'Discover the best creations from the community',
      filters: 'Filters',
    },
    settings: {
      title: 'Settings',
      profile: 'Profile',
      name: 'Name',
      bio: 'Bio',
      bio_ph: 'Tell us about you...',
      save: 'Save',
      saved: 'Saved',
      privacy: 'Privacy',
      privacy_desc: 'Choose whether your songs are public (visible on Explore and via their share link) or private.',
      song: 'Song',
      public: 'Public',
      private: 'Private',
      credits: 'Credits',
      buy: 'Buy credits',
      pack_small: '100 credits pack',
      pack_medium: '500 credits pack',
      pack_large: '2000 credits pack',
      buy_mock: 'MOCKED payment — credits added instantly',
      delete_song: 'Delete',
      confirm_delete: 'Delete this song?',
    },
    profile: {
      follow: 'Follow',
      unfollow: 'Unfollow',
      followers: 'followers',
      following: 'following',
      songs: 'songs',
      no_songs: 'No public songs',
      edit: 'Edit profile',
    },
    share: {
      title: 'Share',
      copy_link: 'Copy link',
      copied: 'Link copied!',
      by: 'by',
      comments: 'Comments',
      comment_ph: 'Leave a comment...',
      send: 'Send',
      sign_in_to_comment: 'Sign in to comment',
    },
    player: {
      play: 'Play',
      pause: 'Pause',
      next: 'Next',
      prev: 'Previous',
      like: 'Like',
      share: 'Share',
      download: 'Download',
      download_song: 'Full song',
      download_vocals: 'Vocals (stem)',
      download_instrumental: 'Instrumental (stem)',
      stems_note: 'Stems are mocked for the demo',
      lyrics: 'Lyrics',
      noTrack: 'No track selected',
    },
    auth: {
      welcome: 'Welcome to',
      tag: 'Make original songs in a few clicks.',
      email: 'Email',
      password: 'Password',
      signin_cta: 'Sign in',
      signup_cta: 'Create account',
      have_account: 'Already have an account?',
      no_account: "Don't have an account?",
      or: 'OR',
      continue_google: 'Continue with Google',
      name: 'Name',
    },
    common: {
      plays: 'plays',
      likes: 'likes',
      by: 'by',
      duration: 'duration',
      copy: 'Copy',
      copied: 'Copied!',
      remix: 'Remix',
      more: 'More',
    }
  }
};

export const t = (lang, path) => {
  const parts = path.split('.');
  let v = dictionaries[lang] || dictionaries.en;
  for (const p of parts) { v = v?.[p]; if (v === undefined) return path; }
  return v;
};
